import React from "react";

import { useSession } from "../Session/SessionContext";
import { isRunningTab, hasPendingCart } from "../Session/sessionSelectors";
import { useVenue } from "../VenueContext";
import { getVenueHasTablePayOrdering } from "../venueSelectors";
import { PendingCartOnTab } from "./PendingCartOnTab";
import { SimpleOrderCart } from "./SimpleOrderCart";
import { TablePayPayment } from "./TablePayPayment";

const Cart = () => {
  const session = useSession();
  const venue = useVenue();
  const tablePayOrdering = getVenueHasTablePayOrdering(venue);
  const customerTab = session.customerTab;

  if (isRunningTab(session) && customerTab) {
    if (tablePayOrdering && hasPendingCart(session)) {
      return <PendingCartOnTab customerTab={customerTab} />;
    }
    return <TablePayPayment customerTab={customerTab} />;
  }
  return <SimpleOrderCart />;
};

export default Cart;
